var leafImgCanvas = function(){
	
	var c = document.getElementById('leafIcon');
	c.height = 18;
	c.width = 18;
	var cx = c.getContext('2d');
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(0,0,1,1);
	cx.fillRect(1,0,1,1);
	cx.fillRect(2,0,1,1);
	cx.fillRect(3,0,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(4,0,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(5,0,1,1);
	cx.fillRect(6,0,1,1);
	cx.fillRect(7,0,1,1);
	cx.fillRect(8,0,1,1);
	cx.fillRect(9,0,1,1);
	cx.fillRect(10,0,1,1);
	cx.fillRect(11,0,1,1);
	cx.fillRect(12,0,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(13,0,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,0,1,1);
	cx.fillRect(15,0,1,1);
	cx.fillRect(16,0,1,1);
	cx.fillRect(17,0,1,1);
	cx.fillRect(0,1,1,1);
	cx.fillRect(1,1,1,1);
	cx.fillRect(2,1,1,1);
	cx.fillRect(3,1,1,1);
	cx.fillRect(4,1,1,1);
	cx.fillRect(5,1,1,1);
	cx.fillRect(6,1,1,1);
	cx.fillRect(7,1,1,1);
	cx.fillRect(8,1,1,1);
	cx.fillRect(9,1,1,1);
	cx.fillRect(10,1,1,1);
	cx.fillRect(11,1,1,1);
	cx.fillRect(12,1,1,1);
	cx.fillRect(13,1,1,1);
	cx.fillRect(14,1,1,1);
	cx.fillRect(15,1,1,1);
	cx.fillRect(16,1,1,1);
	cx.fillRect(17,1,1,1);
	cx.fillRect(0,2,1,1);
	cx.fillStyle="rgba(240,240,240,1)";
	cx.fillRect(1,2,1,1);
	cx.fillStyle="rgba(44,44,44,1)";
	cx.fillRect(2,2,1,1);
	cx.fillStyle="rgba(75,75,75,1)";
	cx.fillRect(3,2,1,1);
	cx.fillStyle="rgba(95,95,95,1)";
	cx.fillRect(4,2,1,1);
	cx.fillStyle="rgba(139,139,139,1)";
	cx.fillRect(5,2,1,1);
	cx.fillStyle="rgba(189,189,189,1)";
	cx.fillRect(6,2,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(7,2,1,1);
	cx.fillRect(8,2,1,1);
	cx.fillRect(9,2,1,1);
	cx.fillRect(10,2,1,1);
	cx.fillRect(11,2,1,1);
	cx.fillRect(12,2,1,1);
	cx.fillRect(13,2,1,1);
	cx.fillRect(14,2,1,1);
	cx.fillStyle="rgba(252,252,252,1)";
	cx.fillRect(15,2,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(16,2,1,1);
	cx.fillRect(17,2,1,1);
	cx.fillRect(0,3,1,1);
	cx.fillRect(1,3,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(2,3,1,1);
	cx.fillStyle="rgba(16,16,16,1)";
	cx.fillRect(3,3,1,1);
	cx.fillStyle="rgba(43,43,43,1)";
	cx.fillRect(4,3,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(5,3,1,1);
	cx.fillRect(6,3,1,1);
	cx.fillRect(7,3,1,1);
	cx.fillStyle="rgba(19,19,19,1)";
	cx.fillRect(8,3,1,1);
	cx.fillStyle="rgba(139,139,139,1)";
	cx.fillRect(9,3,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(10,3,1,1);
	cx.fillRect(11,3,1,1);
	cx.fillRect(12,3,1,1);
	cx.fillRect(13,3,1,1);
	cx.fillStyle="rgba(253,253,253,1)";
	cx.fillRect(14,3,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(15,3,1,1);
	cx.fillRect(16,3,1,1);
	cx.fillRect(17,3,1,1);
	cx.fillRect(0,4,1,1);
	cx.fillRect(1,4,1,1);
	cx.fillStyle="rgba(86,86,86,1)";
	cx.fillRect(2,4,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(3,4,1,1);
	cx.fillStyle="rgba(89,89,89,1)";
	cx.fillRect(4,4,1,1);
	cx.fillStyle="rgba(202,202,202,1)";
	cx.fillRect(5,4,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(6,4,1,1);
	cx.fillRect(7,4,1,1);
	cx.fillRect(8,4,1,1);
	cx.fillRect(9,4,1,1);
	cx.fillRect(10,4,1,1);
	cx.fillStyle="rgba(210,210,210,1)";
	cx.fillRect(11,4,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(12,4,1,1);
	cx.fillRect(13,4,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(14,4,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(15,4,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(16,4,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(17,4,1,1);
	cx.fillRect(0,5,1,1);
	cx.fillRect(1,5,1,1);
	cx.fillStyle="rgba(166,166,166,1)";
	cx.fillRect(2,5,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(3,5,1,1);
	cx.fillRect(4,5,1,1);
	cx.fillStyle="rgba(72,72,72,1)";
	cx.fillRect(5,5,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(6,5,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(7,5,1,1);
	cx.fillRect(8,5,1,1);
	cx.fillRect(9,5,1,1);
	cx.fillRect(10,5,1,1);
	cx.fillRect(11,5,1,1);
	cx.fillStyle="rgba(186,186,186,1)";
	cx.fillRect(12,5,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(13,5,1,1);
	cx.fillRect(14,5,1,1);
	cx.fillRect(15,5,1,1);
	cx.fillRect(16,5,1,1);
	cx.fillRect(17,5,1,1);
	cx.fillRect(0,6,1,1);
	cx.fillRect(1,6,1,1);
	cx.fillStyle="rgba(245,245,245,1)";
	cx.fillRect(2,6,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(3,6,1,1);
	cx.fillRect(4,6,1,1);
	cx.fillRect(5,6,1,1);
	cx.fillStyle="rgba(188,188,188,1)";
	cx.fillRect(6,6,1,1);
	cx.fillStyle="rgba(224,224,224,1)";
	cx.fillRect(7,6,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(8,6,1,1);
	cx.fillRect(9,6,1,1);
	cx.fillRect(10,6,1,1);
	cx.fillRect(11,6,1,1);
	cx.fillRect(12,6,1,1);
	cx.fillStyle="rgba(249,249,249,1)";
	cx.fillRect(13,6,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,6,1,1);
	cx.fillRect(15,6,1,1);
	cx.fillRect(16,6,1,1);
	cx.fillRect(17,6,1,1);
	cx.fillRect(0,7,1,1);
	cx.fillRect(1,7,1,1);
	cx.fillRect(2,7,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(3,7,1,1);
	cx.fillRect(4,7,1,1);
	cx.fillRect(5,7,1,1);
	cx.fillRect(6,7,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(7,7,1,1);
	cx.fillStyle="rgba(85,85,85,1)";
	cx.fillRect(8,7,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(9,7,1,1);
	cx.fillRect(10,7,1,1);
	cx.fillRect(11,7,1,1);
	cx.fillRect(12,7,1,1);
	cx.fillStyle="rgba(97,97,97,1)";
	cx.fillRect(13,7,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,7,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(15,7,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(16,7,1,1);
	cx.fillRect(17,7,1,1);
	cx.fillRect(0,8,1,1);
	cx.fillRect(1,8,1,1);
	cx.fillRect(2,8,1,1);
	cx.fillStyle="rgba(89,89,89,1)";
	cx.fillRect(3,8,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(4,8,1,1);
	cx.fillRect(5,8,1,1);
	cx.fillRect(6,8,1,1);
	cx.fillStyle="rgba(135,135,135,1)";
	cx.fillRect(7,8,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(8,8,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(9,8,1,1);
	cx.fillRect(10,8,1,1);
	cx.fillRect(11,8,1,1);
	cx.fillRect(12,8,1,1);
	cx.fillRect(13,8,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,8,1,1);
	cx.fillRect(15,8,1,1);
	cx.fillRect(16,8,1,1);
	cx.fillRect(17,8,1,1);
	cx.fillRect(0,9,1,1);
	cx.fillRect(1,9,1,1);
	cx.fillRect(2,9,1,1);
	cx.fillStyle="rgba(195,195,195,1)";
	cx.fillRect(3,9,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(4,9,1,1);
	cx.fillRect(5,9,1,1);
	cx.fillRect(6,9,1,1);
	cx.fillRect(7,9,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(8,9,1,1);
	cx.fillStyle="rgba(135,135,135,1)";
	cx.fillRect(9,9,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(10,9,1,1);
	cx.fillRect(11,9,1,1);
	cx.fillRect(12,9,1,1);
	cx.fillRect(13,9,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,9,1,1);
	cx.fillRect(15,9,1,1);
	cx.fillRect(16,9,1,1);
	cx.fillRect(17,9,1,1);
	cx.fillRect(0,10,1,1);
	cx.fillRect(1,10,1,1);
	cx.fillRect(2,10,1,1);
	cx.fillRect(3,10,1,1);
	cx.fillStyle="rgba(6,6,6,1)";
	cx.fillRect(4,10,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(5,10,1,1);
	cx.fillRect(6,10,1,1);
	cx.fillRect(7,10,1,1);
	cx.fillStyle="rgba(36,36,36,1)";
	cx.fillRect(8,10,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(9,10,1,1);
	cx.fillStyle="rgba(4,4,4,1)";
	cx.fillRect(10,10,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(11,10,1,1);
	cx.fillRect(12,10,1,1);
	cx.fillRect(13,10,1,1);
	cx.fillStyle="rgba(250,250,250,1)";
	cx.fillRect(14,10,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(15,10,1,1);
	cx.fillRect(16,10,1,1);
	cx.fillRect(17,10,1,1);
	cx.fillRect(0,11,1,1);
	cx.fillRect(1,11,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(2,11,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(3,11,1,1);
	cx.fillStyle="rgba(202,202,202,1)";
	cx.fillRect(4,11,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(5,11,1,1);
	cx.fillRect(6,11,1,1);
	cx.fillRect(7,11,1,1);
	cx.fillRect(8,11,1,1);
	cx.fillStyle="rgba(105,105,105,1)";
	cx.fillRect(9,11,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(10,11,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(11,11,1,1);
	cx.fillRect(12,11,1,1);
	cx.fillRect(13,11,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,11,1,1);
	cx.fillRect(15,11,1,1);
	cx.fillRect(16,11,1,1);
	cx.fillRect(17,11,1,1);
	cx.fillRect(0,12,1,1);
	cx.fillRect(1,12,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(2,12,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(3,12,1,1);
	cx.fillRect(4,12,1,1);
	cx.fillStyle="rgba(151,151,151,1)";
	cx.fillRect(5,12,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(6,12,1,1);
	cx.fillRect(7,12,1,1);
	cx.fillRect(8,12,1,1);
	cx.fillRect(9,12,1,1);
	cx.fillStyle="rgba(96,96,96,1)";
	cx.fillRect(10,12,1,1);
	cx.fillStyle="rgba(201,201,201,1)";
	cx.fillRect(11,12,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(12,12,1,1);
	cx.fillRect(13,12,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,12,1,1);
	cx.fillRect(15,12,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(16,12,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(17,12,1,1);
	cx.fillRect(0,13,1,1);
	cx.fillRect(1,13,1,1);
	cx.fillStyle="rgba(253,253,253,1)";
	cx.fillRect(2,13,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(3,13,1,1);
	cx.fillRect(4,13,1,1);
	cx.fillRect(5,13,1,1);
	cx.fillStyle="rgba(206,206,206,1)";
	cx.fillRect(6,13,1,1);
	cx.fillStyle="rgba(2,2,2,1)";
	cx.fillRect(7,13,1,1);
	cx.fillStyle="rgba(0,0,0,1)";
	cx.fillRect(8,13,1,1);
	cx.fillRect(9,13,1,1);
	cx.fillRect(10,13,1,1);
	cx.fillRect(11,13,1,1);
	cx.fillStyle="rgba(66,66,66,1)";
	cx.fillRect(12,13,1,1);
	cx.fillStyle="rgba(18,18,18,1)";
	cx.fillRect(13,13,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,13,1,1);
	cx.fillRect(15,13,1,1);
	cx.fillRect(16,13,1,1);
	cx.fillRect(17,13,1,1);
	cx.fillRect(0,14,1,1);
	cx.fillRect(1,14,1,1);
	cx.fillRect(2,14,1,1);
	cx.fillRect(3,14,1,1);
	cx.fillRect(4,14,1,1);
	cx.fillRect(5,14,1,1);
	cx.fillRect(6,14,1,1);
	cx.fillRect(7,14,1,1);
	cx.fillStyle="rgba(196,196,196,1)";
	cx.fillRect(8,14,1,1);
	cx.fillStyle="rgba(118,118,118,1)";
	cx.fillRect(9,14,1,1);
	cx.fillStyle="rgba(94,94,94,1)";
	cx.fillRect(10,14,1,1);
	cx.fillStyle="rgba(112,112,112,1)";
	cx.fillRect(11,14,1,1);
	cx.fillStyle="rgba(161,161,161,1)";
	cx.fillRect(12,14,1,1);
	cx.fillStyle="rgba(111,111,111,1)";
	cx.fillRect(13,14,1,1);
	cx.fillStyle="rgba(152,152,152,1)";
	cx.fillRect(14,14,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(15,14,1,1);
	cx.fillRect(16,14,1,1);
	cx.fillRect(17,14,1,1);
	cx.fillRect(0,15,1,1);
	cx.fillRect(1,15,1,1);
	cx.fillRect(2,15,1,1);
	cx.fillRect(3,15,1,1);
	cx.fillRect(4,15,1,1);
	cx.fillRect(5,15,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(6,15,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(7,15,1,1);
	cx.fillRect(8,15,1,1);
	cx.fillRect(9,15,1,1);
	cx.fillRect(10,15,1,1);
	cx.fillRect(11,15,1,1);
	cx.fillRect(12,15,1,1);
	cx.fillRect(13,15,1,1);
	cx.fillStyle="rgba(107,107,107,1)";
	cx.fillRect(14,15,1,1);
	cx.fillStyle="rgba(144,144,144,1)";
	cx.fillRect(15,15,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(16,15,1,1);
	cx.fillRect(17,15,1,1);
	cx.fillRect(0,16,1,1);
	cx.fillRect(1,16,1,1);
	cx.fillRect(2,16,1,1);
	cx.fillRect(3,16,1,1);
	cx.fillRect(4,16,1,1);
	cx.fillRect(5,16,1,1);
	cx.fillRect(6,16,1,1);
	cx.fillRect(7,16,1,1);
	cx.fillRect(8,16,1,1);
	cx.fillRect(9,16,1,1);
	cx.fillRect(10,16,1,1);
	cx.fillRect(11,16,1,1);
	cx.fillRect(12,16,1,1);
	cx.fillRect(13,16,1,1);
	cx.fillRect(14,16,1,1);
	cx.fillStyle="rgba(131,131,131,1)";
	cx.fillRect(15,16,1,1);
	cx.fillStyle="rgba(232,232,232,1)";
	cx.fillRect(16,16,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(17,16,1,1);
	cx.fillRect(0,17,1,1);
	cx.fillRect(1,17,1,1);
	cx.fillRect(2,17,1,1);
	cx.fillRect(3,17,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(4,17,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(5,17,1,1);
	cx.fillRect(6,17,1,1);
	cx.fillRect(7,17,1,1);
	cx.fillRect(8,17,1,1);
	cx.fillRect(9,17,1,1);
	cx.fillRect(10,17,1,1);
	cx.fillRect(11,17,1,1);
	cx.fillRect(12,17,1,1);
	cx.fillStyle="rgba(254,254,254,1)";
	cx.fillRect(13,17,1,1);
	cx.fillStyle="rgba(255,255,255,1)";
	cx.fillRect(14,17,1,1);
	cx.fillRect(15,17,1,1);
	cx.fillRect(16,17,1,1);
	cx.fillRect(17,17,1,1);
	
	return c;
}

export default leafImgCanvas;
